// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"delta-pro-ultra-daily-use_productcontent__yNu4I"};